<template>
  <div>
    <basic-container>
      <div class="page-container">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <el-input clearable v-model="form.partnerName" placeholder="合作方名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-auth="'ACTIVITY_PARTNER_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
              <el-button v-auth="'ACTIVITY_PARTNER_ADD'" icon="el-icon-plus" plain type="primary" @click="handleAddDialogOpen">新增</el-button>
              <el-button v-auth="'ACTIVITY_PARTNER_DELETE'" :loading="delLoading" icon="el-icon-delete" plain type="danger" @click="handleDelete">删除</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table
            :data="partnerList"
            ref="eltable"
            :height="autoTableHeight"
            v-loading="listLoading"
            @selection-change="handleSelect"
            border
            style="width: 100%">
            <el-table-column
              type="selection"
              header-align="center"
              align="center"
              fixed
              width="48">
            </el-table-column>
            <el-table-column
              type="index"
              header-align="center"
              align="center"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="partnerName"
              label="合作方名称"
              width="250">
            </el-table-column>
            <el-table-column
              prop="partnerCode"
              label="合作方编码"
              width="200">
            </el-table-column>
            <el-table-column
              prop="email"
              label="联系邮箱"
              width="180">
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="联系电话"
              width="180">
            </el-table-column>
            <el-table-column
              prop="createTime"
              header-align="center"
              align="center"
              label="创建时间"
              width="180">
            </el-table-column>
            <el-table-column
              prop="updateTime"
              header-align="center"
              align="center"
              width="180"
              label="更新时间">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注">
            </el-table-column>
            <el-table-column
              prop="name"
              fixed="right"
              label="操作"
              width="80">
              <template slot-scope="scope">
                <el-button v-auth="'ACTIVITY_PARTNER_EDIT'" :size="formSize" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-pagination">
          <TablePagination
            :page-size.sync="pageConfig.size"
            :total="total"
            :current-page.sync="pageConfig.current"
            @change="handlePageChange"
          />
        </div>
      </div>
    </basic-container>
    <el-dialog
      :title="popupTitle"
      :modal="false"
      :close-on-click-modal="false"
      :visible.sync="showPopups"
      width="600px"
      @close="handleClose">
      <div class="popups-from__wrap">
        <el-form :size="formSize" ref="form" :rules="formRules" :model="partnerForm" label-width="120px">
          <el-form-item label="合作方名称" prop="partnerName">
            <el-input style="width: 300px;" v-model="partnerForm.partnerName" placeholder="请输入合作方名称"></el-input>
          </el-form-item>
          <el-form-item label="合作方编码" prop="partnerCode">
            <el-input style="width: 300px;" v-model="partnerForm.partnerCode" placeholder="请输入合作方标识" :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="email">
            <el-input style="width: 300px;" v-model="partnerForm.email" placeholder="请输入联系邮箱"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input style="width: 300px;" v-model="partnerForm.mobile" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input style="width: 300px;"  type="textarea" v-model="partnerForm.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :size="formSize" @click="showPopups = false">取消</el-button>
        <el-button :loading="submitLoading" :size="formSize" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { merge } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
  export default {
    name: 'ActivityPartnerPage',
    mixins: [ListMixins],
    data() {
      return {
        isEdit: false,
        showPopups: false,
        listLoading: false,
        submitLoading: false,
        delLoading: false,
        form: {
          partnerName: ''
        },
        formRules: {
          partnerName: [
            { required: true, message: '合作方名称不能为空', trigger: 'blur' }
          ],
          partnerCode: [
            { required: true, message: '合作方标识不能为空', trigger: 'blur' }
          ],
          email: [
            { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
          ]
        },
        partnerForm: {
          id: '',
          partnerCode: '',
          email: '',
          mobile: '',
          partnerName: '',
          remark: ''
        }
      }
    },
    computed: {
      ...mapState('runActivityManage', ['partnerList', 'total']),
      ...mapGetters('app', ['viewportSize']),
      popupTitle() {
        return this.isEdit ? '编辑' : '新增';
      }
    },
    methods: {
      ...mapActions('runActivityManage', ['getPartnerList', 'submitPartnerForm', 'delPartners']),
      getList() {
        const query = merge({}, this.form, this.pageConfig);
        this.listLoading = true;
        this.getPartnerList(query).finally(() => {
          this.listLoading = false;
        });
      },
      handleAddDialogOpen() {
        this.isEdit = false;
        this.showPopups = true;
      },
      // 编辑数据
      handleEdit(row) {
        for(let key of Object.keys(this.partnerForm)) {
          this.partnerForm[key] = row[key];
        }
        this.isEdit = true;
        this.showPopups = true;
      },
      // 删除数据
      handleDelete() {
        if (this.selectedRows.length > 0) {
          this.$confirm('确定要删除选择的记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const ids = this.selectedRows.map(item => item.id).join(',');
            this.delLoading = true;
            this.delPartners({ ids }).then(isSuccess => {
              if (isSuccess) {
                this.selectedRows = [];
                this.getList();
              }
            }).finally(() => {
              this.delLoading = false;
            });
          })
        } else {
          this.$alert('请选择要删除的记录', '提示', {
            confirmButtonText: '知道了',
          });
        }
      },
      // 打开编辑窗口
      // 保存数据
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            const query = merge({}, this.partnerForm);
            if (!this.isEdit) {
              delete query.id;
            }
            this.submitLoading = true;
            this.submitPartnerForm(query).then(isSuccess => {
              if (isSuccess) {
                this.showPopups = false;
                this.getList();
              }
            }).finally(() => {
              this.submitLoading = false;
            })
          }
        })
      },
      handleClearForm() {
        for (let key in this.partnerForm) {
          this.partnerForm[key] = '';
        }
        this.$refs.form.clearValidate();
      },
      handleClose() {
        this.handleClearForm();
      }
    },
    created() {
      this.getList();
    }
  }
</script>
<style lang="scss">
  .table-pagination {
    margin-top: 20px;
    text-align: right;
  }
</style>